import { Shield, HardHat, MapPin, FileText } from 'lucide-react';

const TrustBadgesStrip = () => {
  const badges = [
    {
      icon: Shield,
      label: 'Fully Insured',
    },
    {
      icon: HardHat,
      label: 'WCB Covered',
    },
    {
      icon: MapPin,
      label: 'Local Calgary Contractor',
    },
    {
      icon: FileText,
      label: 'Free Estimates',
    },
  ];

  return (
    <section className="py-6 bg-[#0f172a] border-t border-[#1e293b]" data-testid="trust-badges-strip">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-3"
              data-testid={`trust-badge-${index}`}
            >
              <div className="w-10 h-10 bg-[#c5a059]/10 rounded-full flex items-center justify-center">
                <badge.icon className="w-5 h-5 text-[#c5a059]" />
              </div>
              <span className="text-white text-sm font-medium tracking-wide">
                {badge.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesStrip;
